export default[
    {
        path: '/tiers/list',
        name: 'tiers-list',
        component: () => import('@/views/tiers/Lists.vue'),
    },
    {
        path: '/tiers/details/{id}',
        name: 'tiers-details',
        component: () => import('@/views/tiers/Details.vue'),
    },
    {
        path: '/tiers/prospects/details',
        name: 'prospects-details',
        component: () => import('@/views/tiers/prospects/Details.vue'),
    },
    // {
    //     path: '/tiers/entreprise/details/:id',
    //     name: 'entreprise-details',
    //     component: () => import('@/views/tiers/entreprise/Details.vue'),
    // }
]
